export default __webpack_public_path__ + "static/admissibilite-aide-juridique-gouvernementale-gratuite-contributive-4b79862f262a2bab6ff7d7100cd05af1.jpeg";